/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
 * Variant Notifier
 */

document.addEventListener('DOMContentLoaded', function () {
  var variantInput = document.querySelector(
    '.ProductNotify input[name="selected_variant_id"]',
  );
  var variantId = variantInput && variantInput.value;
  var subscribeUrl = 'http://variant-notifier.herokuapp.com/api/subscribes';
  var subscribeBtn = document.querySelector('.ProductNotify__Submit');
  var subscribeAlert = document.querySelector('.ProductNotify__Alert');
  var emailInput = document.querySelector('.ProductNotify input[name="email"]');

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant;
    var notifyEl = document.querySelector('.ProductNotify');

    if (!notifyEl) {
      return;
    }

    variantId = variant.id;

    subscribeAlert.style.display = 'none';

    if (variant.available) {
      notifyEl.classList.add('available');
    } else {
      notifyEl.classList.remove('available');
    }
  });

  function toJson(response) {
    return response.json();
  }

  function subscribeFeedback(response) {
    subscribeBtn.disabled = false;

    if (response.success) {
      subscribeAlert.style.display = 'block';
    }
  }

  function subscribeToVariant() {
    var paramsUrl =
      subscribeUrl + '?email=' + emailInput.value + '&variant_id=' + variantId;
    subscribeBtn.disabled = true;

    fetch(paramsUrl).then(toJson).then(subscribeFeedback);
  }

  if (subscribeBtn) {
    subscribeBtn.onclick = subscribeToVariant.bind(this);
  }
});

/* Accessibility */

document.addEventListener('DOMContentLoaded', function () {
  var removeElementsFromFocusTree = function () {
    var notFocusableElements = [
      document.querySelector('.Slideshow .Slideshow__Carousel'),
      document.querySelector('.Product__Slideshow.Carousel'),
    ];

    document.querySelectorAll('.ProductList').forEach(function (productList) {
      notFocusableElements.push(productList);
    });

    notFocusableElements.forEach(function (el) {
      if (!el) {
        return;
      }
      el.setAttribute('tabindex', '-1');
    });
  };

  // Some elements are added dynamically and don't have any events that we can listen to.
  // This timeout is to make sure that the elements were loaded before we remove them from the focus tree.
  setTimeout(removeElementsFromFocusTree, 3000);

  // Skip to Content
  var skipLink = document.getElementById('skip-link');
  var mainContent = document.getElementById('main');

  skipLink.addEventListener('click', function (e) {
    e.preventDefault();
    mainContent.focus();
  });

  // Focus toggle between quick nav links
  var quickNavLinks = document.querySelectorAll(
    '.Product__QuickNav.hidden-pocket a',
  );

  if (quickNavLinks.length > 0) {
    var moreInfoLink = quickNavLinks[0];
    var viewImagesLink = quickNavLinks[1];

    setAriaAttributes(moreInfoLink, viewImagesLink);

    var focusTarget;

    moreInfoLink.addEventListener('click', function (e) {
      e.preventDefault();
      focusTarget = document.querySelector(
        '.Product__Tabs .Collapsible .Collapsible__Button',
      );

      if (focusTarget) {
        focusTarget.focus();
      }
    });

    viewImagesLink.addEventListener('click', function (e) {
      e.preventDefault();
      focusTarget = document.querySelector(
        '.Product__Slideshow',
      ).firstElementChild;

      if (focusTarget) {
        focusTarget.focus();
      }
    });
  }

  function setAriaAttributes(visibleLink, hiddenLink) {
    visibleLink.setAttribute('tabindex', '0');
    visibleLink.setAttribute('aria-hidden', 'false');
    hiddenLink.setAttribute('tabindex', '-1');
    hiddenLink.setAttribute('aria-hidden', 'true');
  }

  function toggleQuickNavLinksVisibility(quickNav) {
    if (quickNav.classList.contains('is-flipped')) {
      setAriaAttributes(viewImagesLink, moreInfoLink);
    } else {
      setAriaAttributes(moreInfoLink, viewImagesLink);
    }
  }

  function classMutationObserver(element, callback) {
    if (!element) {
      return;
    }

    var oldClassList = JSON.stringify(element.classList);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          var target = mutation.target;
          var newClassList = JSON.stringify(target.classList);

          if (oldClassList === newClassList) {
            return;
          }
          callback(target);
          oldClassList = newClassList;
        }
      });
    });

    observer.observe(element, {
      childList: false,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  var quickNav = document.querySelector('.Product__QuickNav.hidden-pocket');

  classMutationObserver(quickNav, toggleQuickNavLinksVisibility);

  // Product Image Zoom Button
  var zoomButtons = document.querySelectorAll('.product-image-zoom');
  var productImageCloseBtn = document.querySelector(
    '.pswp__button.pswp__button--close',
  );

  if (productImageCloseBtn && zoomButtons) {
    productImageCloseBtn.addEventListener('click', function (e) {
      zoomButtons.forEach(button => {
        button.setAttribute('aria-expanded', false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        zoomButtons.forEach(button => {
          button.setAttribute('aria-expanded', false);
        });
      }
    });
    zoomButtons.forEach(button => {
      button.addEventListener('click', function () {
        button.setAttribute('aria-expanded', true);
      });
    });
  }

  // Product Slideshow control
  var slideshowNavDots = document.querySelectorAll('.Product__SlideshowNavDot');

  slideshowNavDots.forEach(function (dot) {
    dot.addEventListener('click', function (e) {
      e.preventDefault();

      dot.parentNode
        .querySelector('.is-selected')
        .classList.remove('is-selected');
      dot.classList.add('is-selected');
      var target = document.getElementById(dot.getAttribute('aria-controls'));

      if (target) {
        target.focus();
      }
    });
  });

  // Adding the proper role to the headers from autogenerated tables (size charts and privacy policy)
  function setHeadersToTables(tables, headerType = 'horizontal') {
    if (headerType === 'horizontal') {
      tables.forEach(function (table) {
        var tableHeaders = table.querySelectorAll('tr:first-child td');

        tableHeaders.forEach(function (header) {
          header.setAttribute('role', 'columnheader');
          header.setAttribute('scope', 'col');
        });
      });
    } else {
      tables.forEach(function (table) {
        var rows = table.querySelectorAll('tr');
        rows.forEach(function (row, index) {
          if (index === 0) {
            row.querySelectorAll('td').forEach(function (header) {
              header.setAttribute('role', 'columnheader');
              header.setAttribute('scope', 'col');
            })
          } else {
            var header = row.children[0];
            if (header) {
              header.setAttribute('role', 'columnheader');
              header.setAttribute('scope', 'row');
            }
          }
        });
      });
    }
  }
  var sizeChartTables = document.querySelectorAll(
    '.Product__Tabs .Collapsible__Content table',
  );
  setHeadersToTables(sizeChartTables, 'vertical');

  var privacyPolicyTables = document.querySelectorAll(
    '.shopify-policy__container table',
  );
  setHeadersToTables(privacyPolicyTables);

  var shippingEstimatorSelects = document.querySelectorAll(
    '.ShippingEstimator__Form select',
  );

  shippingEstimatorSelects.forEach(function (select) {
    select.addEventListener('change', function (e) {
      select.classList.remove('invalid');
      var errorElementId = select.getAttribute('aria-describedby');
      var error = document.getElementById(errorElementId);
      error.innerHTML = '';
    });
  });

  const toolTipForColors = document.querySelectorAll('[data-tooltip]');
  toolTipForColors.forEach(toolTipForColor => {
    toolTipForColor.onclick = () => {
      const selectedColors = document.querySelectorAll('.ColorSelected');
      selectedColors.forEach(item => {
        item.classList.remove('ColorSelected');
      });
      toolTipForColor.classList.add('showTooltip');
      toolTipForColor.classList.add('ColorSelected');
      setTimeout(() => {
        toolTipForColor.classList.remove('showTooltip');
      }, 1200);
    };
  });

  const toolTipElements = document.querySelectorAll('[data-tooltip]');
  if (toolTipElements) {
    toolTipElements.forEach(toolTipElement => {
      const radio = toolTipElement.querySelectorAll('input[type="radio"]');
      if (radio) {
        radio.forEach(item => {
          item.addEventListener('focus', () => {
            toolTipElement.classList.add('showTooltip');
          });
          item.addEventListener('blur', () => {
            toolTipElement.classList.remove('showTooltip');
          });
        });
      }
    });
  }
});
